import { OrderStatus } from "../types/orderStatus";
import { GlobalStore } from "../store/global/GlobalStore";
import { useCallback, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { TIME_BEFORE_USER_IS_IDLE } from "../config/consts";
import { MODAL_SELECTORS } from "../components/Modal/instance/modalSelectors";
import { getWrappedSymbolForChain } from "../utils/chainUtils";
import { Token } from "../store/global/TokenEnum";
import { getSelectedTokenSymbolArray } from "../utils/quoteUtils";

export const useCanQuote = (): boolean => {
  const { makerTokens, takerTokens, orderStatus, modalSelector, network } = GlobalStore.useState(
    s => {
      return {
        makerTokens: s.makerTokens,
        takerTokens: s.takerTokens,
        orderStatus: s.orderStatus,
        modalSelector: s.modalSelector,
        network: s.network,
      };
    }
  );
  const [isUserIdle, setIsUserIdle] = useState<boolean>(false);
  const handleOnIdle = useCallback(() => {
    setIsUserIdle(true);
    GlobalStore.update(s => {
      s.quoteExpired = true;
    });
  }, []);
  const handleOnActive = useCallback(() => {
    setIsUserIdle(false);
  }, []);
  useIdleTimer({
    timeout: TIME_BEFORE_USER_IS_IDLE,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
  });
  const takerTokenHasAnAmount = !takerTokens.some(entry => entry.amount.value.isZero());
  const makerTokensSelected = makerTokens.length > 0;
  const quotableOrderState =
    orderStatus === OrderStatus.ENTRY ||
    orderStatus === OrderStatus.QUOTING ||
    orderStatus === OrderStatus.REVIEW;
  const isNotApprovingTokens = modalSelector !== MODAL_SELECTORS.APPROVE_ALLOWANCE;
  const isUnwrapping =
    getSelectedTokenSymbolArray(takerTokens).includes(getWrappedSymbolForChain(network)) &&
    getSelectedTokenSymbolArray(makerTokens).includes(network.nativeCurrency.symbol as Token);
  const isWrapping =
    getSelectedTokenSymbolArray(makerTokens).includes(getWrappedSymbolForChain(network)) &&
    getSelectedTokenSymbolArray(takerTokens).includes(network.nativeCurrency.symbol as Token);

  const isNotWrappingOrUnwrapping = !isWrapping && !isUnwrapping;
  const canQuote =
    takerTokenHasAnAmount &&
    makerTokensSelected &&
    quotableOrderState &&
    isNotApprovingTokens &&
    isNotWrappingOrUnwrapping;
  return !isUserIdle && canQuote;
};
